document.querySelectorAll('.expandable-content__list').forEach(function (list) {
  var singleOpen = list.dataset.singleOpen === 'true';

  list.addEventListener('click', function (event) {
    var trigger = event.target.closest('.expandable-content__trigger');
    if (!trigger || !list.contains(trigger)) return;

    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (singleOpen && !isOpen) {
      list.querySelectorAll('.expandable-content__trigger[aria-expanded="true"]').forEach(function (openTrigger) {
        if (openTrigger === trigger) return;
        openTrigger.setAttribute('aria-expanded', 'false');
        var openPanel = document.getElementById(openTrigger.getAttribute('aria-controls'));
        if (openPanel) openPanel.classList.remove('is-open');
      });
    }

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.classList.toggle('is-open', !isOpen);
  });
});
